import { del, get, post, put } from './request'

interface RatePlan {
    supplier: string;
    propertyId: string;
    property: {
        rateplans: Array<object>
    };
}

export const getRatePlans = (supplier: string, propertyid: string) => get(`/property/rateplan?supplier=${supplier}&propertyid=${propertyid}`)
export const addRatePlan = (ratePlan: RatePlan) => post('/property/rateplan', ratePlan)
export const updateRatePlan = (ratePlan: RatePlan) => put('/property/rateplan', ratePlan)
export const deleteRatePlan = (ratePlan: RatePlan) => del('/property/rateplan', ratePlan)